// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import {  Modal, ModalHeader, ModalBody} from 'reactstrap';
// import { Loader } from 'react-overlay-loader';
// import { url,logout } from '../components/helper'
// import BranchPanelGroup from '../components/viewBranchSubComponents/branchViewPanelGroup'
// import BottomScrollListener  from 'react-bottom-scroll-listener'
// import loadingGif from '../CSS/assets-minified/images/loadingMore.gif'

// class BranchView extends Component{
//     constructor(props){
//         super(props)

//         this.state = {
//             isAdmin:'',
//             isOrgAdmin:'',
//             isBranchAdmin:'',
//             loading:true,
//             section:0,
//             createBranchModalOpen:false,
//             all_branches:[],
//             contentLoaderHidden:true,
//             currentPage:1,
//             hasNext:false
//         }
//         // this.create_branch = this.create_branch(this)
//         this.loadMore = this.loadMore.bind(this)
//     }

//     componentWillMount = () =>{
//         var cookies = new Cookies();
//         var loginStatus = cookies.get('loggedIn')
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         }
//         var branch_admin = cookies.get('branch-admin')
//         if(branch_admin === 'true'){
//             // window.location = '/dashboard'
//         }
//         var organization_admin = cookies.get('organization-admin')
//         var superuser = cookies.get('superuser')
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         var global_ref = this
//         this.setState({
//             isAdmin:superuser,
//             isOrgAdmin:organization_admin,
//             isBranchAdmin:branch_admin
//         })

//         var http = new XMLHttpRequest();
//         http.open('GET',url+'/api/branch?user_id='+user_id, true)
//         http.setRequestHeader("Authorization", "Token "+token);
//         http.send()

//         http.onreadystatechange = function(){
//             if(http.status === 200 && http.readyState === 4){

//                 var json = JSON.parse(http.responseText)
//                 console.log(json)
//                 if(json.status === 200){
//                     var data = []
//                     json.organisations.forEach(element =>{
//                         if(element.branches !== undefined){
//                             data.push(element)
//                         }
//                     })
//                     global_ref.setState({
//                         all_branches:data,
//                         section:1
//                     })
//                 }

//             }
//             if(http.readyState === 4 && http.status === 401){
//                 logout()
//             }
//         }
//     }

//     loadMore = () =>{
//         if(this.state.hasNext === true){
//             this.setState({
//                 currentPage:this.state.currentPage + 1,
//                 contentLoaderHidden:false
//             })
//             var cookies = new Cookies();
//             var user_id = cookies.get('user_id')
//             var token = cookies.get('token')
//             var global_ref = this

//             var http = new XMLHttpRequest();
//             http.open('GET',url+'/api/branch?user_id='+user_id, true)
//             http.setRequestHeader("Authorization", "Token "+token);
//             http.send()

//             http.onreadystatechange = function(){
//                 if(http.status === 200 && http.readyState === 4){

//                     var json = JSON.parse(http.responseText)

//                     if(json.status === 200){

//                         global_ref.setState({
//                             // all_branches:data,
//                             contentLoaderHidden:true,
//                             hasNext:json.has_next,
//                         })
//                         json.organisations.forEach(element =>{
//                             if(element.branches !== undefined){
//                                 global_ref.setState(prevState => ({
//                                     all_branches: [...prevState.all_branches, element]
//                                   }))
//                             }
//                         })
//                     }

//                 }
//                 if(http.readyState === 4 && http.status === 401){
//                     logout()
//                 }
//         }
//         }
//     }

//     create_branch = () =>{
//         window.location="/create-branch"
//     }

//     render(){
//         if(this.state.section === 0){
//             return(
//                 <div>
//                     <Loader loading={this.state.loading} fullPage={true} />
//                 </div>
//             )
//         }
//         if(this.state.section === 1){
//             if(this.state.isAdmin === 'true' | this.state.isOrgAdmin === 'true'){
//                 return(
//                     <div>
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                         <Modal isOpen={this.state.createBranchModalOpen}>
//                             <ModalHeader>Create Branch</ModalHeader>
//                             <ModalBody>
//                             <form >
//                                 <div className="form-group">
//                                     <label for="branchName">Branch Name</label>
//                                     <input type="text" className="form-control" id="branchName" placeholder="Enter Branch Name"></input>
//                                 </div>

//                                 <div className="form-group">

//                                     <label for="branchAddress">Branch Address</label>
//                                     <input type="text" className="form-control" id="branchAddress" placeholder="Enter Branch Address"></input>
//                                 </div>

//                                 <div className="form-group">
//                                     <label for="GPSLocation">Email address</label>
//                                     <input type="text" className="form-control" id="GPSLocation" placeholder="Enter Branch GPS Location"></input>
//                                 </div>

//                                 <div className="form-group">
//                                     <label for="GPSLocation">Email address</label>
//                                     <input type="text" className="form-control" id="GPSLocation" placeholder="Enter Branch Name"></input>
//                                 </div>

//                             </form>
//                             </ModalBody>
//                         </Modal>
//                         {/* <BranchPanelGroup data={this.state.all_branches}/> */}
//                         <div className="row">
//                             <div className="col-md-4"></div>
//                             <div className="col-md-4"><h1 style={{textAlign:"center"}}>All Branches</h1></div>
//                             <div className="col-md-4">
//                             <button class="btn btn-blue-alt fetch_questions" id="btn" style={{margin:0, width:150,float:"right"}} onClick={this.create_branch.bind(this)} ><i class="fa fa-plus"   style={{marginRight:5}}></i><b>Create Branch</b></button>
//                             </div>
//                         </div>

//                         {this.state.all_branches.map((branch,i)=> <BranchPanelGroup key={i} data={branch}/>)}

//                         {/* <BranchPanelGroup /> */}
//                         </div>
//                         </div>

//                 </div>
//                    )
//             }
//             else{
//                 return(
//                     <div>
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                         {/* <BranchPanelGroup data={this.state.all_branches}/> */}
//                         <div className="row">
//                             {/* <div className="col-md-4"></div> */}
//                             <div className="col-md-12"><h1 style={{textAlign:"center"}}>All Branches</h1></div>

//                         </div>

//                         {this.state.all_branches.map((branch,i)=> <BranchPanelGroup key={i} data={branch}/>)}

//                         {/* <BranchPanelGroup /> */}
//                         </div>
//                         </div>

//                 </div>
//                    )
//             }
//         }
//     }
// }

// export default BranchView

import React from 'react'
import Cookies from 'universal-cookie'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { Loader } from 'react-overlay-loader'

import { url, logout } from '../components/helper'
import BranchPanelGroup from '../components/viewBranchSubComponents/branchViewPanelGroup'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'

const BranchView = () => {
    const [isAdmin, setIsAdmin] = React.useState('')
    const [isOrgAdmin, setIsOrgAdmin] = React.useState('')
    const [isBranchAdmin, setIsBranchAdmin] = React.useState('')
    const [loading, setLoading] = React.useState(true)
    const [section, setSection] = React.useState(0)
    const [createBranchModalOpen, setCreateBranchModalOpen] =
        React.useState(false)
    const [allBranches, setAllBranches] = React.useState([])
    const [contentLoaderHidden, setContentLoaderHidden] = React.useState(true)
    const [currentPage, setCurrentPage] = React.useState(1)
    const [hasNext, setHasNext] = React.useState(false)

    //Check and set valid credentials
    const credentialCheck = () => {
        const cookies = new Cookies()
        const loginStatus = cookies.get('loggedIn')
        if (!loginStatus) {
            window.location = '/login'
        }

        const branchAdmin = cookies.get('branch-admin')
        const organizationAdmin = cookies.get('organization-admin')
        const superUser = cookies.get('superuser')

        setIsAdmin(superUser)
        setIsOrgAdmin(organizationAdmin)
        setIsBranchAdmin(branchAdmin)
    }

    //Get all the branches based on userId credential
    const getAllBranches = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/branch?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let branches = []
                    data.organisations.forEach((org) => {
                        if (org.branches) {
                            branches.push(org)
                        }
                    })
                    setAllBranches(branches)
                    setSection(1)
                    break
                case 401:
                    logout()
                    break
                default:
                    console.error('Invalid Return:', data)
                    break
            }
        } catch (err) {
            console.error('Error')
        }
    }

    //Runs once on initial render
    React.useEffect(() => {
        credentialCheck()
        getAllBranches()
    }, [])

    //Load More details
    const loadMore = async () => {
        if (hasNext) {
            setCurrentPage(currentPage + 1) //Might be problematic
            contentLoaderHidden(false)
        }

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/branch?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setContentLoaderHidden(true)
                    setHasNext(data.has_next)
                    data.organisations.forEach((org) => {
                        if (org.branches) {
                            setAllBranches([...allBranches, org])
                        }
                    })
                    break
                case 401:
                    logout()
                    break
                default:
                    break
            }
        } catch (err) {
            console.error('Error', err)
        }
    }

    //Navidate Create Branches page
    const navigateCreateBranch = () => {
        window.location = '/create-branch'
    }

    return (
        <div>
            {section === 0 ? (
                <div>
                    <Loader loading={loading} fullPage={true} />
                </div>
            ) : (
                <div></div>
            )}

            {section === 1 && (isAdmin === 'true' || isOrgAdmin === 'true') ? (
                <div>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <Modal isOpen={createBranchModalOpen}>
                                <ModalHeader>Create Branch</ModalHeader>
                                <ModalBody>
                                    <form>
                                        <div className="form-group">
                                            <label for="branchName">
                                                Branch Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="branchName"
                                                placeholder="Enter Branch Name"
                                            ></input>
                                        </div>

                                        <div className="form-group">
                                            <label for="branchAddress">
                                                Branch Address
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="branchAddress"
                                                placeholder="Enter Branch Address"
                                            ></input>
                                        </div>

                                        <div className="form-group">
                                            <label for="GPSLocation">
                                                Email address
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="GPSLocation"
                                                placeholder="Enter Branch GPS Location"
                                            ></input>
                                        </div>

                                        <div className="form-group">
                                            <label for="GPSLocation">
                                                Email address
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="GPSLocation"
                                                placeholder="Enter Branch Name"
                                            ></input>
                                        </div>
                                    </form>
                                </ModalBody>
                            </Modal>
                            <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-4">
                                    <h1 style={{ textAlign: 'center' }}>
                                        All Branches
                                    </h1>
                                </div>
                                <div className="col-md-4">
                                    <button
                                        class="btn btn-blue-alt fetch_questions"
                                        id="btn"
                                        style={{
                                            margin: 0,
                                            width: 150,
                                            float: 'right',
                                        }}
                                        onClick={navigateCreateBranch}
                                    >
                                        <i
                                            class="fa fa-plus"
                                            style={{ marginRight: 5 }}
                                        ></i>
                                        <b>Create Branch</b>
                                    </button>
                                </div>
                            </div>

                            {allBranches.map((branch, i) => (
                                <BranchPanelGroup key={i} data={branch} />
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div className="row">
                                {/* <div className="col-md-4"></div> */}
                                <div className="col-md-12">
                                    <h1 style={{ textAlign: 'center' }}>
                                        All Branches
                                    </h1>
                                </div>
                            </div>

                            {allBranches.map((branch, i) => (
                                <BranchPanelGroup key={i} data={branch} />
                            ))}

                            {/* <BranchPanelGroup /> */}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default BranchView

/**
 * Notes
 * - LoadMore and getAllBranch has repeated call to api, might be able to combine them
 * - There is apparently a lock up bug when a branch detail is broken. Edit button subsequnetly breaks
 *
 */



// WEBPACK FOOTER //
// src/Routes/AllBranchesView.js